module.exports = __webpack_public_path__ + "static/media/app-redirect-qr.97608c32.png";